import { insertInfoCards } from "./components/info-cards";
document.addEventListener('DOMContentLoaded', function () {
  insertInfoCards();
  var endlessCollection = new Ajaxinate({
    container: '#product-grid',
    pagination: '.infinite_next',
    callback: function callback() {
      insertInfoCards();
    }
  });
});